import '../app.css'
import { injectAnalytics } from '@vercel/analytics/sveltekit'
import { dev } from '$app/environment'

injectAnalytics({ mode: dev ? 'development' : 'production' })

export const prerender = true

// Vercel default is Node serverless. Avoid `runtime: 'edge'` here: adapter-vercel bundles SSR with
// esbuild, and @sentry/sveltekit currently pulls client modules (`$app/stores`) into that graph,
// which breaks Edge function generation (Vercel build error).
